import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import draftManualHelper from 'views/App/Portal/Policy/DraftManuals/helpers/draftManualHelper';
import { isFullManual } from './PreviewContent';
import type { DraftManual } from 'views/App/Portal/Policy/_types/manuals/draft';

interface PolicyAccreditationTagsProps {
  policyData: any;
  policyAccreditationTags: Record<string, string[]>;
}

export const PolicyAccreditationTags: React.FC<PolicyAccreditationTagsProps> = ({
  policyData,
  policyAccreditationTags,
}) => {
  const contextTags = policyAccreditationTags[policyData.id] || [];

  if (contextTags.length === 0) {
    return null;
  }

  return (
    <>
      <Chip
        label={contextTags[0]}
        variant='filled'
        color='info'
        size='small'
      />
      {contextTags.length > 1 && (
        <Tooltip
          title={contextTags.slice(1).join(', ')}
          placement='top'
        >
          <Chip
            label={`+${contextTags.length - 1}`}
            variant='filled'
            color='info'
            size='small'
          />
        </Tooltip>
      )}
    </>
  );
};

interface AccreditationTagsProps {
  section: any;
  policyData: any;
  manual: any;
  policyAccreditationTags: Record<string, string[]>;
}

const getSectionRuiAccreditationTags = (section: any, policyData: any, manual: any): string[] => {
  if (!policyData || !manual || !isFullManual(manual)) {
    return [];
  }

  const policyNumber = draftManualHelper.getNumberManualNode(policyData, manual);
  let sectionNum: string;

  if ('parentId' in section && section.parentId) {
    const parentSection = policyData.sections.find((s: any) => s.id === section.parentId);

    if (parentSection) {
      const parentSectionIndex = draftManualHelper.getEnabledSectionIndex(parentSection.id, policyData);
      const subSectionIndex = draftManualHelper.getEnabledSubSectionIndex(parentSection.id, section.id, policyData);
      sectionNum = `${policyNumber}.${parentSectionIndex}.${subSectionIndex}`;
    } else {
      sectionNum = `${policyNumber}.${draftManualHelper.getNumberPolicyNode(section, policyData)}`;
    }
  } else {
    const sectionIndex = draftManualHelper.getEnabledSectionIndex(section.id, policyData);
    sectionNum = `${policyNumber}.${sectionIndex}`;
  }

  return [];
};

export const AccreditationTags: React.FC<AccreditationTagsProps> = ({
  section,
  policyData,
  manual,
  policyAccreditationTags,
}) => {
  const ruiTags = getSectionRuiAccreditationTags(section, policyData, manual);
  const hasRuiTags = ruiTags.length > 0;
  const contextTags = policyAccreditationTags[section.id] || [];

  const tagsToShow = hasRuiTags ? ruiTags : contextTags;

  if (tagsToShow.length === 0) {
    return null;
  }

  return (
    <>
      <Chip
        label={tagsToShow[0]}
        variant='filled'
        color='info'
      />
      {tagsToShow.length > 1 && (
        <Tooltip
          title={tagsToShow.slice(1).join(', ')}
          placement='top'
        >
          <Chip
            label={`+${tagsToShow.length - 1}`}
            variant='filled'
            color='info'
          />
        </Tooltip>
      )}
    </>
  );
};
